import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Element } from 'react-scroll';
import IconOpen from '../../assets/icon_mais.png';
import IconClose from '../../assets/icon_menos.png';

const FadeIn = styled.div`
  opacity: 0;
  transform: translateY(50px); /* Aumentei a quantidade de translação */
  transition: opacity 1s ease, transform 1s ease; /* Reduzi a duração da transição */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;


  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
`;


const Container = styled.div`
  background: #151515;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 1000px) {
    overflow-x: hidden !important;
  }
`;


const Line = styled.div`
    margin-top: 2rem;
    background: #FFC222;
    width: 2px;
    height: 75px;
`;

const ControlCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 3rem;

    @media (max-width: 1000px) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;


const Imagem = styled.img`
    width: 26px;
    margin-right: 1.3rem;
`;

const ControllFaq = styled.div`
  width: 500px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1000px) {
    width: 350px;
    }
`;

const ControlTexto = styled.div`
    width: 100%;
    border-radius: 1rem;
    background: #191919;
    padding: 1rem;
    display: flex;
    justify-content: start;
    align-items: center;
    flex-direction: row;
    margin-bottom: 1rem;
    cursor: pointer;
`;

const Title = styled.h1`
    color: white;
    margin-bottom: 24px;
    text-align: center;

    span{
    color: #FFC222;
  }
`;

const Text = styled.p`
    color: white;
    font-weight: 600;
    font-size: 1.3rem;
`;

const SubText = styled.p`
    color: #c3c3c3;
    font-weight: 400;
    font-size: 1.3rem;
    margin-bottom: 14px;
`;

const Linkada = styled.a`
  color: #FFC222;
  margin: 0.5rem;
  transition: 500ms;
  font-size: 1.2rem;
  text-align: center;

  &:hover{
    filter: brightness(0.8);
  }
`;

function Faq() {
    const { t } = useTranslation();
    const [openCard, setOpenCard] = useState(null);

    const toggleCard = (index) => {
        setOpenCard(openCard === index ? null : index);
    };


          const cardsData = [
            {
              icon: IconOpen,
              text: t('faq-1-infinox'),
              subText: t('faq-2-infinox')
          },
          {
            icon: IconOpen,
            text: t('faq-3-infinox'),
            subText: t('faq-4-infinox')
          },
          {
            icon: IconOpen,
            text: t('faq-5-infinox'),
            subText: t('faq-6-infinox'),
            link2: "https://www.infinox.com/documents/legal-documents/FSC/2023/Evidence-of-Insurance-Certificate.pdf"
          },
          {
            icon: IconOpen,
            text: t('faq-7-infinox'),
            subText: t('faq-8-infinox'),
            link: "https://www.citi.com/"
          },
          {
            icon: IconOpen,
            text: t('faq-9-infinox'),
            subText: t('faq-10-infinox')
          },
          {
            icon: IconOpen,
            text: t('faq-11-infinox'),
            subText: t('faq-12-infinox')
          },
          {
            icon: IconOpen,
            text: t('faq-13-infinox'),
            subText: t('faq-14-infinox')
          },
      ];


  return (

    <Container>
            <ControlCard>
                <Title>FAQ Infinox<span>.</span></Title>

                <ControllFaq>
                    {cardsData.map((card, index) => (
                        <div key={index}>
                            <ControlTexto onClick={() => toggleCard(index)}>
                                <Imagem src={openCard === index ? IconClose : card.icon} alt="Icone"  />
                                <Text>{card.text}</Text>
                            </ControlTexto>
                            {openCard === index && (
                                <div>
                                <SubText>{card.subText}</SubText>
                                <Linkada href={card.link} target="_blank">{card.link}</Linkada>
                                </div>
                            )}
                             {openCard === index && (
                                <div>
                                <Linkada href={card.link2} target="_blank">{card.link2}</Linkada>
                                </div>
                            )}
                        </div>
                    ))}
                </ControllFaq>
            </ControlCard>
</Container>

  );
}

export default Faq;
